interface NumberInputProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  prefix?: string;
  suffix?: string;
  helperText?: string;
  id?: string;
}

export default function NumberInput({
  label,
  value,
  onChange,
  min = 0,
  max,
  step = 1,
  prefix,
  suffix,
  helperText,
  id,
}: NumberInputProps) {
  const inputId = id || `input-${label.replace(/\s+/g, '-').toLowerCase()}`;

  return (
    <div className="flex flex-col gap-2">
      <label htmlFor={inputId} className="text-navy-700 font-semibold text-sm">
        {label}
      </label>
      <div className="relative">
        {prefix && (
          <span className="absolute left-4 top-1/2 -translate-y-1/2 text-teal-600 font-bold text-lg pointer-events-none">
            {prefix}
          </span>
        )}
        <input
          id={inputId}
          type="number"
          value={Number.isNaN(value) ? '' : value}
          onChange={(e) => {
            const n = parseFloat(e.target.value);
            onChange(Number.isNaN(n) ? 0 : n);
          }}
          min={min}
          max={max}
          step={step}
          className={`w-full ${prefix ? 'pl-10' : 'pl-4'} ${
            suffix ? 'pr-16' : 'pr-4'
          } py-3 border border-navy-200 rounded-lg focus:border-teal-500 focus:ring-2 focus:ring-teal-500/20 focus:outline-none text-navy-900 font-bold text-lg transition-colors`}
        />
        {suffix && (
          <span className="absolute right-4 top-1/2 -translate-y-1/2 text-teal-600 font-bold text-lg pointer-events-none">
            {suffix}
          </span>
        )}
      </div>
      {helperText && <p className="text-navy-500 text-xs">{helperText}</p>}
    </div>
  );
}
